import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";

// The App component is the root of the application.
import App from "./App";
import ErrorBoundary from "./components/layout/ErrorBoundary";
import { cognitoConfig } from "./config/auth.config";
import "./assets/styles/main.scss";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element is not found");
}
const root = ReactDOM.createRoot(rootElement);

root.render(
  // Wrap the application in React.StrictMode to help identify potential issues in dev mode.
  <React.StrictMode>
    {/* Last line of defence: catches render errors that no page or section boundary handled, so the user never sees a blank page. */}
    <ErrorBoundary level="app">
      <BrowserRouter>
        <AuthProvider {...cognitoConfig}>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
